import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { Search, Trash2, CheckCircle2, XCircle, Crown } from "lucide-react";
import { fmtDate } from "@/components/admin/AdminShared";

export const AdminUsersTab = ({ users, q, setQ, onSearch, onToggleDisable, onUpgradePlan, onConfirmDelete }) => (
  <Card className="bg-af-card border-af rounded-md overflow-hidden">
    <form onSubmit={onSearch} className="p-4 border-b border-af flex gap-2">
      <div className="relative flex-1">
        <Search className="h-4 w-4 absolute left-3 top-3 text-af-muted" />
        <Input value={q} onChange={(e) => setQ(e.target.value)}
          placeholder="Rechercher par email ou nom…"
          data-testid="admin-search-input"
          className="pl-9 border-af focus-visible:ring-terracotta" />
      </div>
      <Button type="submit" className="bg-terracotta hover:bg-[#9C7124] text-white rounded-md" data-testid="admin-search-btn">
        Rechercher
      </Button>
    </form>
    <div className="overflow-x-auto">
      <table className="w-full text-sm" data-testid="admin-users-table">
        <thead className="bg-af-subtle text-af-muted text-xs uppercase tracking-wider">
          <tr>
            <th className="text-left px-4 py-3 font-semibold">Utilisateur</th>
            <th className="text-left px-4 py-3 font-semibold">Plan</th>
            <th className="text-left px-4 py-3 font-semibold">Inscrit</th>
            <th className="text-left px-4 py-3 font-semibold">Dernière connexion</th>
            <th className="text-left px-4 py-3 font-semibold">Réunions</th>
            <th className="text-right px-4 py-3 font-semibold">Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.map((u) => (
            <tr key={u.id} className={"border-t border-af " + (u.disabled ? "bg-[#FFF1F2]/40" : "")}
              data-testid={`admin-user-row-${u.email}`}>
              <td className="px-4 py-3">
                <div className="font-semibold text-af flex items-center gap-2">
                  {u.full_name}
                  {u.is_super_admin && (
                    <Badge className="bg-terracotta text-white text-[9px] uppercase tracking-wider rounded-sm border-0">Admin</Badge>
                  )}
                  {u.disabled && (
                    <Badge variant="outline" className="border-[#9F1239] text-[#9F1239] text-[9px] uppercase tracking-wider rounded-sm">Désactivé</Badge>
                  )}
                </div>
                <div className="text-xs text-af-muted">{u.email}</div>
              </td>
              <td className="px-4 py-3">
                {u.plan === "business" ? (
                  <Badge className="bg-[#2B1F12] text-white border-0 rounded-sm"><Crown className="h-3 w-3 mr-1" /> Business</Badge>
                ) : (
                  <Badge variant="outline" className="border-af text-af-secondary rounded-sm">Gratuit</Badge>
                )}
              </td>
              <td className="px-4 py-3 text-af-secondary">{fmtDate(u.created_at)}</td>
              <td className="px-4 py-3 text-af-secondary">{fmtDate(u.last_login_at)}</td>
              <td className="px-4 py-3 text-af-secondary font-semibold">{u.meetings_count}</td>
              <td className="px-4 py-3 text-right">
                <div className="inline-flex gap-1">
                  {u.plan === "free" ? (
                    <Button size="sm" variant="ghost" onClick={() => onUpgradePlan(u, "business")}
                      data-testid={`upgrade-${u.email}`} className="text-terracotta hover:bg-[#F5EFD8] h-8 px-2">
                      <Crown className="h-3.5 w-3.5 mr-1" /> Upgrade
                    </Button>
                  ) : !u.is_super_admin && (
                    <Button size="sm" variant="ghost" onClick={() => onUpgradePlan(u, "free")}
                      className="text-af-secondary hover:bg-af-subtle h-8 px-2">
                      Downgrade
                    </Button>
                  )}
                  {!u.is_super_admin && (
                    <>
                      <Button size="sm" variant="ghost" onClick={() => onToggleDisable(u)}
                        data-testid={`toggle-${u.email}`}
                        className={"h-8 px-2 " + (u.disabled ? "text-emerald-700 hover:bg-emerald-50" : "text-amber-700 hover:bg-amber-50")}>
                        {u.disabled ? <CheckCircle2 className="h-3.5 w-3.5 mr-1" /> : <XCircle className="h-3.5 w-3.5 mr-1" />}
                        {u.disabled ? "Activer" : "Désactiver"}
                      </Button>
                      <Button size="sm" variant="ghost" onClick={() => onConfirmDelete(u)}
                        data-testid={`delete-${u.email}`}
                        className="text-[#9F1239] hover:bg-[#FFF1F2] h-8 px-2">
                        <Trash2 className="h-3.5 w-3.5" />
                      </Button>
                    </>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {users.length === 0 && (
        <div className="p-10 text-center text-af-muted text-sm">Aucun utilisateur trouvé.</div>
      )}
    </div>
  </Card>
);
